import { Card, CardContent, CardHeader, Grid, Typography } from '@mui/material';
import { theme } from 'theme';
import { jbColors } from 'theme/jbColors';
import { palette } from 'theme/palette';
import { ProposalRow } from 'views/Case/ProposalRow';
import { DocumentStatuses, ProposalDocumentClassTypes } from 'types';
import { CaseProposal } from 'pco-product-service-internal-consumer';
import { formatNumber } from 'utils/stringUtils';

const styles = {
  title: {
    color: palette.black,
  },
  card: {
    padding: theme.spacing(2),
  },
  cardContent: {
    padding: theme.spacing(2),
    paddingTop: theme.spacing(0),
  },
  gridItem: {
    marginBottom: theme.spacing(2),
  },
};

type Props = {
  proposal: CaseProposal;
};
export const Proposal = ({ proposal }: Props) => {
  const findClientShortListAndReturnId = () => {
    const document = (proposal.documents ?? []).find(
      (doc) => doc.name === ProposalDocumentClassTypes.CLIENT_PRESENTATION_SHORT,
    );
    return document?.id;
  };

  return (
    <Card
      data-testid="proposal"
      square
      style={{
        backgroundColor: jbColors.core.stone[10],
        marginBottom: theme.spacing(2),
      }}
    >
      <CardHeader title={proposal.proposalName} titleTypographyProps={{ variant: 'subtitle2' }} sx={styles.card} />

      <CardContent sx={styles.cardContent}>
        {proposal.profile && proposal.investment && proposal.currency && proposal.bookingCenter && (
          <Grid container direction={'row'}>
            <Grid item container direction={'column'} xs={2} sx={styles.gridItem}>
              <Grid item>
                <Typography variant={'caption'}>Profile</Typography>
              </Grid>
              <Grid item>
                <Typography>{proposal.profile}</Typography>
              </Grid>
            </Grid>
            <Grid item container direction={'column'} xs={2}>
              <Grid item>
                <Typography variant={'caption'}>Investment</Typography>
              </Grid>
              <Grid item>
                <Typography>{`${formatNumber(proposal.investment)} ${proposal.currency}`}</Typography>
              </Grid>
            </Grid>
            <Grid item container direction={'column'} xs={2}>
              <Grid item>
                <Typography variant={'caption'}>Booking center</Typography>
              </Grid>
              <Grid item>
                <Typography>{proposal.bookingCenter}</Typography>
              </Grid>
            </Grid>
          </Grid>
        )}
        {(proposal.documents ?? [])
          .filter((doc) => doc.name !== ProposalDocumentClassTypes.CLIENT_PRESENTATION_SHORT)
          .map((proposalRow, i) => {
            return (
              <ProposalRow
                key={`proposal-row-${proposalRow.id}-${i}`}
                name={proposalRow.name ?? ''}
                status={(proposalRow.status ?? '') as DocumentStatuses}
                id={proposalRow.id ?? ''}
                shortListId={
                  proposalRow.name === ProposalDocumentClassTypes.CLIENT_PRESENTATION
                    ? findClientShortListAndReturnId()
                    : undefined
                }
              />
            );
          })}
      </CardContent>
    </Card>
  );
};
